import { userService } from "../../services";
import { history } from "../../helpers/history";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import {
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
} from "../constant/actionTypes";

import { alertActions } from "./alertAction";

export const userActions = {
  login,
  logout,
  register,
};

export function failure(error) {
  return {
    type: LOGIN_FAILURE,
    error,
  };
}

function Redirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/home", { replace: true });
  }, []);

  return true;
}

function login(email, password, props, loadingFalse) {
  return (dispatch) => {
    dispatch(
      request({
        email,
      })
    );

    userService.login(email, password, props).then(
      (user) => {
        if (user.data === null) {
          loadingFalse();
          return dispatch(failure("Something Went Wrong"));
        }
        if (user.data.success === true) {
          loadingFalse();
          console.log("user logged successful", user);
          dispatch(success(user));
          props.navigate("/home");
          //window.location("/home");

          return;
          //return <Navigate to="/home" replace={true} />;
        } else {
          loadingFalse();
          dispatch(failure(user.data.message));
          console.log("user failed to loggeed", user);
        }
      }
      // error => {
      //     dispatch(failure(error));
      //     dispatch(alertActions.error(error));
      // }
    );
  };

  function request(user) {
    return {
      type: LOGIN_REQUEST,
      user,
    };
  }

  function success(user) {
    return {
      type: LOGIN_SUCCESS,
      user,
    };
  }

  function failure(error) {
    return {
      type: LOGIN_FAILURE,
      error,
    };
  }
}

function logout() {
  userService.logout();
  return { type: LOGOUT };
}

function register(user, props) {
  console.log(props, "action props");
  return (dispatch) => {
    dispatch(request(user));
    userService.register(user, props).then(
      (user) => {
        dispatch(success());
        // navigate('/login');
        dispatch(
          alertActions.success("Registration successful. Login to Continue!")
        );
      },
      (error) => {
        console.log(error, "error--------------------------");
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(user) {
    return {
      type: REGISTER_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: REGISTER_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return { type: REGISTER_FAILURE, error };
  }
}
